import React from "react";
import { cn } from "@/lib/utils";
import { colorStyle } from "../../services/visitReasons/types";

type VisitReasonBadgeProps = {
  label?: string | null;
  color?: string | null;
  /** Précision libre affichée à la suite du libellé. */
  note?: string | null;
  className?: string;
};

/**
 * Pastille de couleur d'un motif de visite (file médecin, file secrétaire,
 * écran de gestion). Ne rend rien sans libellé (entrées antérieures au motif).
 */
const VisitReasonBadge: React.FC<VisitReasonBadgeProps> = ({ label, color, note, className }) => {
  if (!label) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        colorStyle(color).badge,
        className
      )}
      title={note ? `${label} — ${note}` : label}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", colorStyle(color).dot)} aria-hidden />
      {label}
      {note && <span className="font-normal opacity-80 truncate max-w-[220px]">· {note}</span>}
    </span>
  );
};

export default VisitReasonBadge;
